import TableAvatar from './TableAvatar';
export default TableAvatar;
